// extracted by mini-css-extract-plugin
export var searchHeader = "_2x-0";
export var searchHeaderDark = "_2x-1";